import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import Flex from '../../../../../components/common/Flex';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import AlertasDetonadasChart from './AlertasDetonadasChart';
import classNames from 'classnames';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../../../../components/common/IconButton';

const AlertasDetonadas = ({
    data,
    total,
    onSelectAlertType,
    highlightedAlertType,
    vehiculoFiltrado,
    alertaFiltrada,
    handleFiltro,
    verDetalle,
    setVerDetalle
}) => {
    // Validar datos
    if (!Array.isArray(data) || data.length === 0) {
        return null; // Se evita renderizar si no hay datos
    }
    // Calcular el total sumando todos los targets (si no se recibió como prop)
    let totalEventos = total || data.reduce((sum, alert) => sum + alert.target, 0);
    let dataFiltered = null;

    if (highlightedAlertType) {
        dataFiltered = data.filter(item => item.title == highlightedAlertType);
        totalEventos = dataFiltered.reduce((sum, alert) => sum + alert.target, 0);
    }

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <Card className="h-100">
            <FalconCardHeader
                title={alertaFiltrada != null
                    ? `Alertas Detonadas: ${vehiculoFiltrado != null ? vehiculoFiltrado.title + " / " : ""}${alertaFiltrada}`
                    : `Alertas Detonadas ${vehiculoFiltrado != null ? ": " + vehiculoFiltrado.title : ""}`}
                //title={alertaFiltrada != null ? `Alertas Detonadas: ${vehiculoFiltrado != null ? vehiculoFiltrado.title + " / " : ""}${alertaFiltrada}` : "Alertas Detonadas"}
                titleTag="h6"
                light
                endEl=
                {
                    <div className='p-0 m-0'>
                        {alertaFiltrada != null && (
                            <IconButton className='mx-2' onClick={handleFiltro} icon="times-circle" size="sm" variant="falcon-default">
                                Remover filtro
                            </IconButton>
                        )}

                        {/*<IconButton onClick={() => setVerDetalle(!verDetalle)} icon="eye" size="sm" variant="falcon-default">
                            {!verDetalle ? 'Ver detalle' : 'Ocultar detalle'}
                        </IconButton>*/}
                    </div>
                }
            />
            <Card.Body as={Row}>
                {/* ✅ GRÁFICO DE DONA */}
                <Col xs={(4)} className="mb-xxl-1 align-content-center">
                    <AlertasDetonadasChart
                        data={dataFiltered || data}
                        onSelectAlertType={onSelectAlertType}
                        total={totalEventos}
                    />
                </Col>

                {/* ✅ DETALLE DE VEHÍCULOS */}
                <Col xs={8} hidden={!verDetalle}>
                    <div className="overflow-auto pe-x1" style={{ maxHeight: '300px' }}>
                        <div style={{ minWidth: '300px' }}>
                            <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
                            {data.map((item, index) => {
                                let isLast = index === data.length - 1;
                                let highlighted = highlightedAlertType === item.title;
                                return (<div key={item.id || item.title || index}>
                                    <Row
                                        className={classNames(
                                            'position-relative align-items-center py-2 g-0 flex-nowrap',
                                            { 'border-bottom border-200': !isLast },
                                            { 'text-danger fw-bold': highlighted }
                                        )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                                            e.preventDefault();
                                            onSelectAlertType(item.title);
                                        }}
                                    >
                                        <Col className="py-1 ps-x1">
                                            <Flex className="justify-content-between"  >
                                                <Row className='mx-0 px-0' style={{ width: '55%' }}>
                                                    <Flex className={classNames(
                                                        'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                                        { 'fw-bold': highlighted }
                                                    )} tag="h6" style={{ ...style }}>
                                                        <a className={classNames('label-detail-card px-0 mx-0', {
                                                            'fw-bold': highlighted,
                                                        })}
                                                            style={{ fontSize: '14px', ...style, color: highlighted ? item.color : '#212121' }}
                                                            title={item.title}>
                                                            {item.title}
                                                        </a>
                                                    </Flex>
                                                </Row>
                                                <Row className="flex-nowrap justify-content-between g-0" >

                                                    <div className='ps-2 text-start m-0' style={{ width: '50%' }}>
                                                        <Badge pill bg="200" className=' mt-0'>
                                                            <div className="m-0 fs-10 fw-semibold" style={{ color: highlighted ? item.color : '#212121' }}>{item.target} alertas</div>
                                                        </Badge>
                                                    </div>
                                                    <div className="ps-2 justify-content-end d-flex flex-nowrap" style={{ width: '50%' }}>

                                                        <Badge pill bg="200" className="my-1 text-primary" style={{ width: '60px' }}>
                                                            {item.amount}%
                                                        </Badge>
                                                        <a className="ps-2" style={{
                                                            color: highlighted ? item.color : 'inherit', width: '20px'
                                                        }}>
                                                            <FontAwesomeIcon icon={faArrowRight} />
                                                        </a>
                                                    </div>
                                                </Row>
                                            </Flex>
                                        </Col >
                                    </Row >
                                </div >
                                )
                            })}
                        </div>
                    </div>
                </Col>
            </Card.Body>
        </Card>
    );
};

AlertasDetonadas.propTypes = {
    // Ahora esperamos un array ya agrupado por tipo de alerta
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.string.isRequired,
        target: PropTypes.number.isRequired,
        amount: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired
    })).isRequired,
    total: PropTypes.number, // Total general, opcional (se calcula si no está)
    onSelectAlertType: PropTypes.func.isRequired,
    highlightedAlertType: PropTypes.string,
    vehiculoFiltrado: PropTypes.string,
    alertaFiltrada: PropTypes.string,
    handleFiltro: PropTypes.func
};

export default memo(AlertasDetonadas);


// import React, { useEffect, useState,memo } from 'react';
// import PropTypes from 'prop-types';
// import CardDropdown from '../../../../../components/common/CardDropdown';
// import Flex from '../../../../../components/common/Flex';
// import { Card, Col, Row } from 'react-bootstrap';
// import AlertasDetonadasChart from './AlertasDetonadasChart';
// import FalconCardFooterLink from '../../../../../components/common/FalconCardFooterLink';
// import classNames from 'classnames';
// import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
// import IconButton from '../../../../../components/common/IconButton';

// // Crea el worker usando import.meta.url (Vite/CRA modernos)
// const createWorker = () => {
//     return new Worker(
//         new URL('./alertasDetonadasWorker.js', import.meta.url)
//     );
// };

// const AlertasDetonadas = ({
//     data,
//     onSelectAlertType,
//     highlightedAlertType,
//     vehiculoFiltrado,
//     alertaFiltrada,
//     handleFiltro
// }) => {
//     const [alertasFormatted, setAlertasFormatted] = useState([]);

//     useEffect(() => {
//         if (!Array.isArray(data) || data.length === 0) {
//             setAlertasFormatted([]);
//             return;
//         }
//         const worker = createWorker();
//         //worker.onmessage = (e) => setAlertasFormatted(e.data);
//         worker.onmessage = (e) => {
//             // Solo actualiza si los datos realmente cambiaron
//             setAlertasFormatted(prev => {
//                 const newData = e.data;
//                 if (JSON.stringify(prev) === JSON.stringify(newData)) return prev;
//                 return newData;
//             });
//         };
//         worker.postMessage({ data });
//         return () => worker.terminate();
//     }, [data]);

//     if (!Array.isArray(alertasFormatted) || alertasFormatted.length === 0) {
//         return null; // Se Evita renderizar si no hay datos
//     }

//     const totalEventos = alertasFormatted.reduce((sum, alert) => sum + alert.target, 0);

//     return (
//         <Card className="h-100">
//             <FalconCardHeader
//                 title={alertaFiltrada != null ? `Alertas Detonadas: ${vehiculoFiltrado != null ? vehiculoFiltrado + " / " : ""}${alertaFiltrada}` : "Alertas Detonadas"}
//                 titleTag="h6"
//                 light
//                 endEl={alertaFiltrada != null && (
//                     <IconButton onClick={handleFiltro} icon="times-circle" size="sm" variant="falcon-default">
//                         Remover filtro
//                     </IconButton>
//                 )}
//             />
//             <Card.Body as={Row}>
//                 <Col md={4} className="mb-xxl-1">
//                     <AlertasDetonadasChart data={alertasFormatted} onSelectAlertType={onSelectAlertType} />
//                 </Col>
//                 <Col md={8}>
//                     {/* Detalle alertas */}
//                     <div className="overflow-auto pe-x1" style={{ maxHeight: '250px' }}>
//                         <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
//                         {alertasFormatted.map((item, index) => (
//                             <Flex
//                                 key={item.id}
//                                 justifyContent="between"
//                                 alignItems="center"
//                                 className={classNames('border-bottom py-3', {
//                                     'border-bottom-0 pb-0': index === alertasFormatted.length - 1,
//                                     'fw-bold': highlightedAlertType === item.title
//                                 })}
//                                 style={{
//                                     color: highlightedAlertType === item.title ? item.color : 'inherit'
//                                 }}
//                             >
//                                 <Flex style={{ width: '160px' }}>
//                                     <h6
//                                         className={classNames('text-truncate mb-0', {
//                                             'fw-bold': highlightedAlertType === item.title
//                                         })}
//                                         style={{
//                                             maxWidth: '180px',
//                                             whiteSpace: 'nowrap',
//                                             overflow: 'hidden',
//                                             textOverflow: 'ellipsis',
//                                             color: highlightedAlertType === item.title ? item.color : 'inherit'
//                                         }}
//                                         title={item.title}
//                                     >
//                                         {item.title}
//                                     </h6>
//                                 </Flex>
//                                 <Flex style={{ width: '100px' }}>
//                                     <p className="fs-10 text-500 mb-0 fw-semibold">{item.target} Alertas</p>
//                                 </Flex>
//                                 <h6 className="text-700 mb-0">{item.amount}%</h6>
//                                 <a
//                                     className={classNames('text-800', {
//                                         'fw-bold': highlightedAlertType === item.title
//                                     })}
//                                     href="#!"
//                                     style={{
//                                         color: highlightedAlertType === item.title ? item.color : 'inherit'
//                                     }}
//                                     onClick={() => onSelectAlertType(item.title)}
//                                 >
//                                     <FontAwesomeIcon icon={faArrowRight} />
//                                 </a>
//                             </Flex>
//                         ))}
//                     </div>
//                 </Col>
//             </Card.Body>
//         </Card>
//     );
// };

// AlertasDetonadas.propTypes = {
//     data: PropTypes.arrayOf(PropTypes.shape({
//         alerta: PropTypes.string,
//         icono_alerta: PropTypes.string,
//         color: PropTypes.string
//     })).isRequired,
//     onSelectAlertType: PropTypes.func.isRequired,
//     highlightedAlertType: PropTypes.string,
//     vehiculoFiltrado: PropTypes.string,
//     alertaFiltrada: PropTypes.string,
//     handleFiltro: PropTypes.func
// };

// //export default AlertasDetonadas;
// export default memo(AlertasDetonadas);




// import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import CardDropdown from '../../../../../components/common/CardDropdown';
// import Flex from '../../../../../components/common/Flex';
// import { Card, Col, Row } from 'react-bootstrap';
// import AlertasDetonadasChart from './AlertasDetonadasChart';
// import FalconCardFooterLink from '../../../../../components/common/FalconCardFooterLink';
// import classNames from 'classnames';
// import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight } from '@fortawesome/free-solid-svg-icons'; //
// import IconButton from '../../../../../components/common/IconButton';
// import { filter } from 'underscore';

// const AlertasDetonadas = ({ data, onSelectAlertType, highlightedAlertType, vehiculoFiltrado, alertaFiltrada, handleFiltro }) => {

//     if (!Array.isArray(data) || data.length === 0) {
//         return null; // Se Evita renderizar si no hay datos
//     }

//     // Agrupar alertas por nombre y calcular total de cada una
//     const alertasMap = {};

//     data.forEach(alert => {
//         if (!alertasMap[alert.alerta]) {
//             alertasMap[alert.alerta] = {
//                 id: alert.alerta,
//                 title: alert.alerta,
//                 target: 0,
//                 img: alert.icono_alerta,
//                 amount: 0,
//                 color: alert.color // Se recibe el color desde el padre
//             };
//         }
//         alertasMap[alert.alerta].target += 1;
//     });

//     // Convertir el mapa a un array
//     const alertasFormatted = Object.values(alertasMap);

//     // Calcular el total de eventos para obtener los porcentajes
//     const totalEventos = alertasFormatted.reduce((sum, alert) => sum + alert.target, 0);
//     alertasFormatted.forEach(alert => {
//         alert.amount = totalEventos > 0 ? ((alert.target / totalEventos) * 100).toFixed(1) : 0;
//     });

//     // 🔹 Ordenar por cantidad de alertas (de mayor a menor)
//     alertasFormatted.sort((a, b) => b.target - a.target);
//     return (
//         <Card className="h-100">
//             <FalconCardHeader
//                 title={alertaFiltrada != null ? `Alertas Detonadas: ${vehiculoFiltrado != null ? vehiculoFiltrado + " / " : ""}${alertaFiltrada}` : "Alertas Detonadas"}
//                 titleTag="h6"
//                 light
//                 // className="border-200 border-bottom py-2"
//                 // endEl={<CardDropdown />}
//                 endEl={alertaFiltrada != null && (<IconButton onClick={handleFiltro} icon="times-circle" size="sm" variant="falcon-default">Remover filtro</IconButton>)}
//             />
//             <Card.Body as={Row}>
//                 <Col md={4} className="mb-xxl-1">
//                     <AlertasDetonadasChart data={alertasFormatted} onSelectAlertType={onSelectAlertType} />
//                 </Col>
//                 <Col md={8}>
//                     {/* Detalle alertas */}
//                     <div className="overflow-auto pe-x1" style={{ maxHeight: '250px' }}>
//                         <hr className="mx-ncard mb-0 d-md-none d-xxl-block" />
//                         {alertasFormatted.map((item, index) => (
//                             <Flex
//                                 key={item.id}
//                                 justifyContent="between"
//                                 alignItems="center"
//                                 className={classNames('border-bottom py-3', {
//                                     'border-bottom-0 pb-0': index === alertasFormatted.length - 1,
//                                     'fw-bold': highlightedAlertType === item.title
//                                 })}
//                                 style={{
//                                     color: highlightedAlertType === item.title ? item.color : 'inherit'  //resaltamos alerta segun el color asignado
//                                 }}
//                             >
//                                 <Flex style={{ width: '160px' }}> {/* Ajustar ancho máximo del contenedor */}
//                                     <h6
//                                         className={classNames('text-truncate mb-0', {
//                                             'fw-bold': highlightedAlertType === item.title // 🚀 Resaltar si es la alerta seleccionada con el color asignado
//                                         })}
//                                         style={{ maxWidth: '180px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: highlightedAlertType === item.title ? item.color : 'inherit' }}
//                                         title={item.title} // Mostrar tooltip con el texto completo
//                                     >
//                                         {item.title}
//                                     </h6>
//                                 </Flex>
//                                 <Flex style={{ width: '100px' }}>

//                                     <p className="fs-10 text-500 mb-0 fw-semibold">{item.target} Alertas</p>
//                                 </Flex>
//                                 <h6 className="text-700 mb-0">{item.amount}%</h6>
//                                 <a
//                                     className={classNames('text-800', {
//                                         'fw-bold': highlightedAlertType === item.title // 🚀 Resaltar si es la alerta seleccionada con el color asignado
//                                     })}
//                                     href="#!"
//                                     style={{
//                                         color: highlightedAlertType === item.title ? item.color : 'inherit'  //resaltamos alerta segun el color asignado
//                                     }}
//                                     onClick={() => onSelectAlertType(item.title)}
//                                 >
//                                     <FontAwesomeIcon icon={faArrowRight} />
//                                 </a>
//                             </Flex>
//                         ))}
//                     </div>
//                 </Col>

//             </Card.Body>
//             {/* <FalconCardFooterLink title="Ver más" size="sm" to="#!"/> */}
//         </Card>
//     );
// };

// AlertasDetonadas.propTypes = {
//     data: PropTypes.arrayOf(PropTypes.shape({
//         alerta: PropTypes.string,
//         icono_alerta: PropTypes.string
//     })).isRequired,
//     onSelectAlertType: PropTypes.func.isRequired, // 📌 Nueva función para seleccionar alertas
//     highlightedAlertType: PropTypes.string // 📌 Estado de alerta seleccionada
// };

// export default AlertasDetonadas;
